
import { createRouter, createWebHistory } from 'vue-router'
import HomeIndex from '@/views/HomeIndex.vue'; // 导入你的组件，例如Home组件
import Home from '@/views/Home.vue';
import AboutMe from "@/views/AboutMe.vue";
import ContactUs from "@/views/ContactUs.vue";
import CompanyNews from "@/views/CompanyNews.vue";
import CompanyNewsDetial from "@/views/CompanyNewsDetial.vue";
import CustomerCase from "@/views/CustomerCase.vue";
import CustomerCaseDetial from "@/views/CustomerCaseDetial.vue";
import CompanyTechnology from "@/views/CompanyTechnology.vue";
import CompanyTechnologyDetial from "@/views/CompanyTechnologyDetial.vue";
import ProductGroup from "@/views/ProductGroup.vue"; // 导入你的组件，例如Home组件
import Product from "@/views/Product.vue"; // 导入你的组件，例如Home组件

const routes = [
    {
        path: '/', // 根路径
        component: Home // 对应的组件
    },
    {
        path: '/info',
        component: HomeIndex
    },
    {
        path: '/aboutme',
        component: AboutMe
    },{
        path: '/contactus',
        component: ContactUs
    },{
        path: '/companynews',
        component: CompanyNews
    },{
        path: '/companynewsdetial/:id',
        component: CompanyNewsDetial
    },{
        path: '/customercase/:id',
        component: CustomerCase
    },{
        path: '/customercasedetial/:id',
        component: CustomerCaseDetial
    },{
        path: '/companytechnology',
        component: CompanyTechnology
    },{
        path: '/companytechnologydetial/:id',
        component: CompanyTechnologyDetial
    },{
        path: '/productgroup/:id',
        component: ProductGroup
    },{
        path: '/product/:id',
        component: Product
    }
];

const router = createRouter({
    history: createWebHistory(),
    routes
});

export default router; // 导出router实例，以便在main.js中引入使用